
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections-and-research/collections",
      function () {
        return require("private-next-pages/collections-and-research/collections/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collections-and-research/collections"])
      });
    }
  